/* External */
import { v4 as uuid } from 'uuid';

/* Utils */
import { createDeferredPromise } from '../../createDeferredPromise';
import Subscription from '../../Subscription';

const ALLOWED_ORIGIN = 'file://';

export const isInsideIFrame = window.parent && window.parent !== window;
const requestsPromises = new Map();
export const relaunchSubscription = Subscription();
const REQUEST_TYPES = {
  ERROR: 'ERROR',
  RESPONSE: 'RESPONSE',
};
const RELAUNCH = 'RELAUNCH';

export function postMessageToParent(type, message) {
  if (isInsideIFrame) {
    window.parent.postMessage({ ...message, type }, ALLOWED_ORIGIN);
  }
}

export function sendRequestToParent(type, message) {
  if (isInsideIFrame) {
    const deferred = createDeferredPromise();
    const requestIdentifier = uuid();
    requestsPromises.set(requestIdentifier, deferred);

    postMessageToParent(type, { ...message, requestIdentifier });

    return deferred.promise;
  }

  return Promise.resolve();
}

export function onMessage({ data, origin }) {
  if (origin !== ALLOWED_ORIGIN) return;
  const {
    requestIdentifier, value, type, error,
  } = data;

  if (type === RELAUNCH) {
    relaunchSubscription.notifySubscribers();
  }

  if (!requestIdentifier) return;

  const deferred = requestsPromises.get(requestIdentifier);
  if (!deferred) return;

  if (type === REQUEST_TYPES.RESPONSE) {
    deferred.resolve(value);
  } else if (type === REQUEST_TYPES.ERROR) {
    const errorToRejectWith = new Error(error.message);
    errorToRejectWith.data = error.data;
    errorToRejectWith.stack = error.stack;
    errorToRejectWith.name = error.name;
    deferred.reject(errorToRejectWith);
  }
  requestsPromises.delete(requestIdentifier);
}
